
type FormatUserFullNameParamsType = {
  firstName: string;
  lastName: string;
  preferredFirstName?: string;
  fallback?: string;
};

type FormatUserFullNameFunctionType = (params: FormatUserFullNameParamsType) => string;

export const formatUserFullName: FormatUserFullNameFunctionType = ({ firstName, lastName, preferredFirstName, fallback = '' }) => {
  if (preferredFirstName || firstName || lastName) {
    return `${preferredFirstName || firstName} ${lastName}`;
  }

  return fallback;
};

export type DisplayName = {
  first: string;
  last: string;
};

type GetUserFullName = (firstName: string, lastName: string, preferredName?: string) => DisplayName;

export const getUserFullName: GetUserFullName = (firstName, lastName, preferredName) => ({
  first: `${preferredName || firstName}`,
  last: lastName,
});

export const getInitials = (firstName: string, lastName: string): string => {
  const first = firstName[0].toUpperCase();

  const last = lastName[0].toUpperCase();

  return `${first}${last}`;
};

const avatarColorMap: Record<string, string> = {
  A: '#C62828',
  B: '#AD1457',
  C: '#6A1B9A',
  D: '#4527A0',
  E: '#283593',
  F: '#1565C0',
  G: '#0277BD',
  H: '#00838F',
  I: '#00695C',
  J: '#2E7D32',
  K: '#558B2F',
  L: '#827717',
  M: '#E65100',
  N: '#BF360C',
  O: '#4E342E',
  P: '#37474F',
  Q: '#424242',
  R: '#880E4F',
  S: '#4A148C',
  T: '#1A237E',
  U: '#006064',
  V: '#1B5E20',
  W: '#E53935',
  X: '#D81B60',
  Y: '#5E35B1',
  Z: '#004D40',
};

export const getAvatarColor = (firstName?: string): string => {
  const letter = firstName?.[0]?.toUpperCase() ?? '';

  return (letter && avatarColorMap[letter]) ?? '#424242';
};
